import api from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../node_modules/postcss-loader/dist/cjs.js??ref--7-2!../../../../node_modules/less-loader/dist/cjs.js??ref--7-3!./index.less";

var options = {"attributes":{"data-injector":"video"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};